import { Spinner } from "neetoui";

import BrowserPreview from "components/BrowserPreview";

import ElementPopup from "./ElementPopup";
import FloatingPopup from "./FloatingPopup";
import Iframe from "./Iframe";
import Inline from "./Inline";
import { buildIframeURL } from "./utils";

import { EMBED_OPTIONS } from "../constants";
import useProductEmbedStore from "../useProductEmbedStore";

const Preview = ({
  isScriptLoading,
  selectedEmbed,
  id,
  customization,
  customPreviewIframeUrl = "",
}) => {
  const { queryParams } = useProductEmbedStore.pick();

  const preview = {
    [EMBED_OPTIONS.INLINE]: Inline,
    [EMBED_OPTIONS.FLOATING_POPUP]: FloatingPopup,
    [EMBED_OPTIONS.ELEMENT_POPUP]: ElementPopup,
    [EMBED_OPTIONS.IFRAME]: Iframe,
  };

  const previewURL = customPreviewIframeUrl || `${location.origin}/embed/${id}`;

  const iframeURL = buildIframeURL({
    previewURL,
    selectedEmbed,
    queryParams,
    customization,
  });

  const Component = preview[selectedEmbed];

  if (isScriptLoading) {
    return (
      <div className="flex min-h-0 flex-grow items-center justify-center overflow-y-auto">
        <Spinner />
      </div>
    );
  }

  return (
    <BrowserPreview
      className="h-full"
      wrapperClassName="neeto-molecules-embed__browser-preview pointer-events-auto"
    >
      <Component {...{ customization, iframeURL }} />
    </BrowserPreview>
  );
};

export default Preview;
